import React, {useEffect} from 'react'
import {useQueryParams} from 'lib/url'
import {useEventRoutes} from 'organization/Event/EventRoutes'
import {useHistory} from 'react-router-dom'

export const CLICK_FUNNELS_EVENT_AUTH_ROUTE_KEY = '__click_funnels_auth_event__'

export default function AuthCallbackHandler() {
  const path = loadEventAuthRoute()
  const history = useHistory()

  const {code} = useQueryParams()

  useEffect(() => {
    if (!path) {
      return
    }

    const withCode = `${path}?code=${code}`
    history.push(withCode)
  }, [history, path, code])

  if (!path) {
    return <div>Authentication failed - route not set.</div>
  }

  return null
}

export function useSetEventAuthRoute() {
  const routes = useEventRoutes()
  const path = routes.services.click_funnels

  return () => {
    window.localStorage.setItem(CLICK_FUNNELS_EVENT_AUTH_ROUTE_KEY, path)
  }
}

function loadEventAuthRoute() {
  return window.localStorage.getItem(CLICK_FUNNELS_EVENT_AUTH_ROUTE_KEY)
}
